module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_back.314de76a.svg";